import { cn } from "@/lib/utils";

type SpinnerIconProps = {
  className?: string;
};

/**
 * Renders a clean, scalable spinner icon using only SVG, without background or extra inline-block/size hack styles.
 *
 * Use Tailwind classes with `className` for size/color, e.g.:
 *   - "w-3 h-3" or "size-[13px]"
 *   - "text-primary" or "text-[#56565C]"
 * Typically best used with "align-middle" or "inline" on parent for vertical alignment.
 */
export function SpinnerIcon({ className }: SpinnerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      className={cn(className)}
      width="1em"
      height="1em"
      focusable="false"
      aria-hidden="true"
    >
      {/* Track */}
      <circle
        cx="8"
        cy="8"
        r="6"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.2"
        fill="none"
      />
      {/* Spinning arc */}
      <path
        d="M14 8a6 6 0 0 0-6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
